import type { UserPublicID } from "../UserPublicId";

export const DUMMY_USER_ID = "default" as UserPublicID;
